// extracted by mini-css-extract-plugin
export default {"quantityLabel":"styles_quantityLabel__ub114","iconTooltip":"styles_iconTooltip__hi20G"};